import React, { useMemo, useState } from "react";
import { formatInTimeZone } from "date-fns-tz";

type DateRangeProps = {
  startDate: string;
  endDate: string;
};

// Extract date formatting logic into its own memoized component
const DateRange: React.FC<DateRangeProps> = React.memo(
  ({ startDate, endDate }) => {
    return (
      <span className="text-xs 2xl:text-sm font-normal text-neutral-500 whitespace-nowrap">
        {formatInTimeZone(new Date(startDate), "UTC", "MMM d")} -{" "}
        {formatInTimeZone(new Date(endDate), "UTC", "MMM d")}
      </span>
    );
  }
);

DateRange.displayName = "DateRange";

interface BasicInfoProps {
  tripName: string;
  startDate: string;
  endDate: string;
}

const BasicInfo: React.FC<BasicInfoProps> = ({
  tripName,
  startDate,
  endDate,
}) => {
  if (!tripName || !startDate || !endDate) return null;

  return (
    <div className="flex flex-col sm:flex-row items-center px-3 sm:px-4 py-2 2xl:py-2.5 space-y-1 sm:space-y-0 sm:space-x-2 rounded-full bg-white border border-indigo-100 shadow-sm w-full sm:w-auto">
      <h1 className="text-sm 2xl:text-base font-medium text-neutral-800 truncate w-full sm:max-w-[200px] text-center sm:text-left">
        {tripName}
      </h1>
      <DateRange startDate={startDate} endDate={endDate} />
    </div>
  );
};

BasicInfo.displayName = "BasicInfo";

export default BasicInfo;
